/**
 * API Configuration for Firebase Cloud Functions
 * 
 * In production: Uses Firebase Cloud Functions URL
 * In development: Uses local emulator or custom API URL
 */

// Get the API base URL
// Priority:
// 1. REACT_APP_API_URL (explicit API URL - recommended)
// 2. Firebase Cloud Functions URL pattern (using project config)
// 3. Local emulator fallback
function getApiBaseUrl() {
  // Explicit API URL (for Firebase Cloud Functions or custom endpoint)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  // Firebase Cloud Functions URL pattern
  // Format: https://{region}-{project-id}.cloudfunctions.net/api
  const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
  const region = process.env.REACT_APP_FIREBASE_REGION || 'asia-south1';
  
  if (projectId) {
    return `https://${region}-${projectId}.cloudfunctions.net/api`;
  }

  // Fallback for local development with emulators
  // Default emulator port for Cloud Functions is 5001
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:5001/your-project-id/asia-south1/api';
  }

  // Last resort: return empty (will need to be configured)
  console.warn('API URL not configured. Please set REACT_APP_API_URL or REACT_APP_FIREBASE_PROJECT_ID');
  return '';
}

export const API_BASE_URL = getApiBaseUrl();

// Helper function to build full API endpoint
export function getApiEndpoint(path) {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${API_BASE_URL}/${cleanPath}`;
}

export default {
  API_BASE_URL,
  getApiEndpoint,
};

